import { render, staticRenderFns } from "./AproveButton.vue?vue&type=template&id=9c719b86&scoped=true"
import script from "./AproveButton.vue?vue&type=script&lang=js"
export * from "./AproveButton.vue?vue&type=script&lang=js"
import style0 from "./AproveButton.vue?vue&type=style&index=0&id=9c719b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c719b86",
  null
  
)

export default component.exports